import getChromeExtensions from './chrome-extensions.js';
import { isAndroid } from '/fp/platform.mjs';
import { triState } from '/fp/options.mjs';

/**
 * Extension probes run by default except on Android (`fp.extensions: 'auto'`). `true`/`'on'` forces
 * them there too; `false`/`'off'` skips them (and the chrome-extension:// fetch 404 noise) everywhere:
 * `rsSDK('config', appId, { fp: { extensions: false } })`.
 *
 * @param {object} [options]
 * @returns {boolean}
 */
export function shouldCollectExtensions(options) {
    const flag = triState(options && options.fp ? options.fp.extensions : undefined);
    if (flag !== null) return flag;
    return !isAndroid();
}

export default async function getExtensions() {
    const chromeExtensions = await getChromeExtensions();
    
    return {
        grammarly: isGrammarlyInstalled(),
        chrome: chromeExtensions
    }
}

function isGrammarlyInstalled() {
    return document.getElementsByTagName('grammarly-desktop-integration').length?true:false;
}